import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  MenuItem,
  Box,
  DialogActions,
  Button,
} from "@mui/material";
import { Form, Formik } from "formik";
import { ReactElement } from "react";
import * as Yup from "yup";

import { OverlapSuppressionFilterType } from "~frontend/__generated__/graphql";
import { FormikSelect } from "~frontend/components/forms/FormSelect";
import { FormikSubmitButton } from "~frontend/components/forms/SubmitButton";

import { FormikTagMultiSelect } from "../../campaignEditorUtils/TagMultiSelect";
import filterLabels from "../filterLabels";

export default function OverlapFilterDialog({
  open,
  onSubmit,
  onClose,
  selectedOverlapIds,
}: {
  open: boolean;
  onSubmit: (values: {
    filter: OverlapSuppressionFilterType | "";
    filterTagIds: string[] | null;
  }) => Promise<void>;
  onClose: () => void;
  selectedOverlapIds: string[];
}): ReactElement {
  return (
    <Formik
      initialValues={{ filter: "", filterTagIds: [] }}
      onSubmit={onSubmit}
      validationSchema={Yup.object().shape({
        filter: Yup.string().required(),
        filterTagIds: Yup.array()
          .of(Yup.string())
          .when("filter", {
            is: OverlapSuppressionFilterType.Tagged,
            then: Yup.array()
              .of(Yup.string())
              .required()
              .min(1, "Must select at least one tag"),
          }),
      })}
    >
      {({ values, submitForm }) => (
        <Form>
          <Dialog open={open}>
            <DialogTitle sx={{ paddingTop: "24px", paddingBottom: "8px" }}>
              Filter Contacts to Suppress from {selectedOverlapIds.length}{" "}
              Campaigns
            </DialogTitle>
            <DialogContent>
              <Typography sx={{ paddingBottom: "24px" }}>
                Apply filters to suppress a targeted selection of overlaps from
                these campaigns.
              </Typography>
              <FormikSelect
                name="filter"
                fullWidth
                label="Contacts Filter"
                withNoneOption={false}
              >
                {Object.values(OverlapSuppressionFilterType).map(filter => (
                  <MenuItem value={filter} key={filter}>
                    {filterLabels[filter]}
                  </MenuItem>
                ))}
              </FormikSelect>
              {values.filter === OverlapSuppressionFilterType.Tagged && (
                <Box sx={{ paddingLeft: "40px" }}>
                  <FormikTagMultiSelect
                    label="Tags"
                    name="filterTagIds"
                    fullWidth
                  />
                </Box>
              )}
            </DialogContent>
            <DialogActions sx={{ paddingRight: "24px", paddingBottom: "24px" }}>
              <Button onClick={onClose} color="tertiary" variant="contained">
                Cancel
              </Button>
              <FormikSubmitButton onClick={submitForm}>
                Save Suppressions
              </FormikSubmitButton>
            </DialogActions>
          </Dialog>
        </Form>
      )}
    </Formik>
  );
}
